const transformCountry = ({ name , code , store , disable_shop  })=>({
        name,
        code,
        defaultStore: store,
        disableShop: disable_shop
    });
const transformGetCoreGeolocationGeocountriesResponse = (data)=>data?.map(({ _id , countries  })=>({
            groupId: _id,
            countries: countries.map(transformCountry).sort((a, b)=>a.name > b.name ? 1 : b.name > a.name ? -1 : 0)
        })).sort((a, b)=>a.groupId > b.groupId ? 1 : b.groupId > a.groupId ? -1 : 0);

export { transformCountry, transformGetCoreGeolocationGeocountriesResponse };
